const i18n = {
  'limit': {
    'user': {
      'title': '建立使用者上限',
      'message': '請洽詢系統商新增使用者人數',
      'buttonText': '回到「職員列表」'
    }
  }
}
export default i18n